import { AccountInfo, IPublicClientApplication } from "@azure/msal-browser";
import { TimePeriod } from "../types/TimePeriod";
import { SubordinateSummary } from "../types/SubordinateSummary";
import { ProjectCheck } from "../types/ProjectCheck";
import { UpdateProjectCheckDTO } from "../types/UpdateProjectCheckDTO";

import { authenticatedBackendFetch } from "./ApiService";

const mailServiceUrl = process.env.REACT_APP_MAILSERVICE_URL;

export async function GetSubordinatesStatusesAsync(
  instance: IPublicClientApplication,
  account: AccountInfo,
  userId: number,
  timePeriod: TimePeriod,
) {
  const response = await authenticatedBackendFetch(
    `supervisors/${userId}/subordinates?month=${timePeriod.Month}&year=${timePeriod.Year}`,
    instance,
    account,
  );

  if (!response.ok) {
    console.error(response);
    return;
  }

  const subordinates: SubordinateSummary[] = await response.json();

  const sortedsubordinates = subordinates.sort((a, b) =>
    a.displayName.toLowerCase().localeCompare(b.displayName.toLowerCase()),
  );

  return sortedsubordinates;
}

export async function SaveSupervisorProjectCheckChangesAsync(
  instance: IPublicClientApplication,
  account: AccountInfo,
  projectChecks: ProjectCheck[],
) {
  let updateDTOs: UpdateProjectCheckDTO[] = [];

  projectChecks.forEach((check) => {
    updateDTOs.push({
      id: check.id,
      checkedByManager: check.checkedByManager,
      managerComment: check.managerComment,
      checkedBySupervisor: check.checkedBySupervisor,
      supervisorComment: check.supervisorComment,
    });
  });

  const response = await authenticatedBackendFetch(`supervisors/projects/save`, instance, account, {
    method: "POST",
    body: JSON.stringify(updateDTOs),
  });

  if (!response.ok) {
    console.error(response);
    throw new Error("BadRequest");
  }
}

export async function SendReminderToManagerAsync(managerMail: string, month: number, year: number) {
  const requestBody = { managerEmail: managerMail, month, year };

  const response = await fetch(`${mailServiceUrl}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(requestBody),
  });

  if (!response.ok) {
    console.error(response);
    throw new Error("BadRequest");
  }
}
